import { Center, Flex } from '@chakra-ui/react';
import { Clock } from '@kula-ai/icons-core';
import { SearchItemWrapper } from './SearchItemWrapper';
import { useSearchManager } from '../search-manager';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';

export const RecentSearchItem = ({ text }: { text: string }) => {
  const { setSearchText } = useSearchManager();

  return (
    <SearchItemWrapper
      wrapperProps={{
        className: `universal--search--item`,
        onClick: () => setSearchText(text),
      }}
    >
      <Flex alignItems="center" gap="12px">
        <Center width="36px" height="36px" borderRadius="xs" bg="secondary-50">
          <Clock
            size="1rem"
            color="var(--kula-colors-secondary-700)"
            className="kula-icon"
          />
        </Center>
        <TruncatedTextWithTooltip
          variant="paragraph"
          color="primary-900"
          text={text}
          maxW="885px"
        />
      </Flex>
    </SearchItemWrapper>
  );
};
